import { ModalWrapper } from 'src/components/ModalWrapper';
import { MESSAGE_STATUS, useMessageContext, useBuyItem, useThrottle } from 'react-easyrocket';
import { Button } from 'src/components/Buttons/Button';
import { useTranslation } from 'react-i18next';
import { useModalContext } from 'src/hooks/useModalContext';
import { ModalProps } from './types';
import { ShopModalContainer } from './components/ShopModalContainer';
import { FreespinsPurchaseBlock } from 'src/pages/Shop/AuthorizedShop/components/FreespinsPurchaseBlock';
import { THREE_SECONDS } from 'src/constants';

export const BuyFreespinsModal = () => {
  const { closeModal, modalProps } = useModalContext<ModalProps>();
  const { mutateAsync: buyShopItem } = useBuyItem({});
  const { openMessage } = useMessageContext();
  const { t } = useTranslation();

  const onBuyButtonClick = useThrottle(() => {
    // eslint-disable-next-line camelcase
    modalProps?.item && buyShopItem({ item_id: modalProps?.item.id });
    closeModal();
  }, THREE_SECONDS);

  return (
    <ModalWrapper showCross={false} isTransparentBg>
      <ShopModalContainer title="shop.freeSpins" text="bonusPage.doYouWantFs">
        <div className="flex flex-col items-center mb-[50px]">
          <FreespinsPurchaseBlock item={modalProps?.item} />
          <Button
            className="w-[165px] self-center"
            onClick={() => {
              openMessage?.(t('shop.successfully'), MESSAGE_STATUS.SUCCESS);
              onBuyButtonClick?.();
            }}>
            {t('freeSpins.accept')}
          </Button>
        </div>
      </ShopModalContainer>
    </ModalWrapper>
  );
};
